module.exports = __webpack_public_path__ + "static/media/icon-layout.8a437d55.svg";